$(document).ready(() => {
  let timer = null;
  let delayHide = null;

  function searchLive(query) {
    timer = null;
    $.get("/search/live/?query=" + query, function(data) {
      $("#search-live-results").html(data);
    });
  }

  $("#search-query").on("input", function() {
    clearTimeout(delayHide);
    const query = $(this).val();
    if (query.length > 0) {
      $("#search-live-results").show();
    } else {
      $("#search-live-results").hide();
    }
    $("#search-live-results").html(
      `<div class="alert p-2">Searching for ${query}...</div>`
    );
    if (timer !== null) {
      clearTimeout(timer);
    }
    timer = setTimeout(function() {
      searchLive(query);
    }, 1000);
  });

  $("#search-live-results").on("mouseenter", event => {
    clearTimeout(delayHide);
  });

  $("#search-live-results").on("mouseleave", event => {
    delayHide = setTimeout(() => {
      $(event.currentTarget).css("display", "none");
    }, 1000);
  });
});
